import React, {type ReactNode, useCallback, useEffect, useRef, useState} from 'react'
import clsx from 'clsx'
import styles from './ScrollFadeContainer.module.scss'

export interface ScrollFadeContainerProps {
    className?: string
    children: ReactNode
    fadeTop?: boolean
    fadeBottom?: boolean
}

export const ScrollFadeContainer = ({
    className,
    children,
    fadeTop = false,
    fadeBottom = false,
}: ScrollFadeContainerProps) => {
    const ref = useRef<HTMLDivElement>(null)
    const [isAtTop, setIsAtTop] = useState(true)
    const [isAtBottom, setIsAtBottom] = useState(false)

    const handleScroll = useCallback(() => {
        const el = ref.current
        if(!el) return
        setIsAtTop(el.scrollTop <= 1)
        setIsAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1)
    }, [])

    useEffect(() => {
        const el = ref.current
        if(!el) return

        el.addEventListener('scroll', handleScroll, {passive: true})
        handleScroll()
        return () => el.removeEventListener('scroll', handleScroll)
    }, [handleScroll])

    return (
        <div
            ref={ref}
            className={clsx(styles.scrollFadeContainer, {
                [styles.fadeTop]: fadeTop && !isAtTop,
                [styles.fadeBottom]: fadeBottom && !isAtBottom,
            }, className)}
        >
            {children}
        </div>
    )
}
